<template>
 <div class="operate_right blue">
   <div class="or_title">
     各料场超低排放设备一览表
   </div>
   <div class="table_box">
     <div class="table_title">
       <div class="title_first">序号</div>
       <div class="title_second">料场名称</div>
       <div class="title_third">超低排放设备配备情况</div>
     </div>
     <vue3-seamless-scroll
       :hover="true"
       :wheel="true"
       :step="0.5"
       :list="tableData"
       class="scroll"
     >
       <ul class="tableList" v-for="(item, index) in tableData" :key="index">
         <li class="table_first">{{ item.num }}</li>
         <li class="table_second">{{ item.stockyardName }}</li>
         <li class="table_third">{{ item.allocation }}</li>
       </ul>
     </vue3-seamless-scroll>
   </div>
 </div>
</template>

<script>
import jsonData from  '/public/static/js/json/operateManage.json';
import {dateFormat} from 'utils/tools';
import { Vue3SeamlessScroll } from "vue3-seamless-scroll";
export default {
  name: 'index',
  data() {
    return {
      isChoose: true,
      page_total: 0,
      tableData: [],
      paramsList: {
        startTime: dateFormat(
          "YYYY-mm-dd HH:MM:SS",
          new Date(new Date() - 24 * 60 * 60 * 1000)
        ),
        endTime: dateFormat("YYYY-mm-dd HH:MM:SS", new Date()),
        pageNo: 1,
        pageSize: 12,
      },
    }
  },
  components: {
    Vue3SeamlessScroll
  },
  mounted() {
    this.tableData = jsonData.generalSurvey;
  }
}
</script>

<style lang="scss" scoped>
.operate_right {
  transition: none 0s ease 0s;
  padding-top: 10px;
  height: 100%;
  margin-left: 20px;
  padding-left: 15px;
  padding-right: 15px;
  @include bg-box(100%, 100%, 'right.png');
  .or_title {
    font-size: 30px;
    color: #63F2EF;
    padding-left: 20px;
    font-weight: 600;
    justify-content: center;
  }
  .isBaoSteel {
    background: #020F3F;
  }
  .box_wrap {
    height: 100%;
  }
  .or_title {
    display: flex;
    .show_more {
      margin-left: auto;
      font-size: 20px;
      margin-right: 10px;
    }
  }
  .table_box {
    background: transparent;
    overflow-x: auto;
    margin-top: 10px;
    .table_title {
      display: flex;
      font-size: 20px;
      background: #194c63;
      height: 50px;
      border: 1px solid #4a7d9e;
      line-height: 50px;
      .title_first {
        width: 70px;
        text-align: center;
        border: 1px solid #4a7d9e;
        color: #4be8d7;
      }
      .title_second {
        width: 170px;
        text-align: center;
        border: 1px solid #4a7d9e;
        color: #4be8d7;
      }
      .title_third {
        width: 445px;
        text-align: center;
        border: 1px solid #4a7d9e;
        color: #4be8d7;
      }
    }

    .scroll {
      height: 670px;
      //width: 500px;
      overflow: hidden;
      .tableList {
        display: flex;
        border: 1px solid #4a7d9e;
        height: 60px;
        background: #0e434d;
        font-size: 18px;
        .table_first {
          width: 70px;
          text-align: center;
          line-height: 60px;
        }
        .table_second {
          width: 170px;
          text-align: center;
          line-height: 60px;
        }
        .table_third {
          width: 445px;
          display: flex;
          align-items: center;
        }
        li {
          border: 1px solid #4a7d9e;
        }
      }
      .tableList:nth-child(even) {
        background: #1d5269;
      }
    }
  }
}
.blue {
  border: 1px solid rgba(132, 170, 255, 0.5);
}
.operate_right :deep(.el-pagination) {
  span:not([class*="suffix"]),
  .el-pagination button {
    line-height: 32px;
    font-size: 16px;
  }
}

.operate_right :deep(.el-pagination__editor) {
  .el-input__inner {
    height: 20px !important;
    font-size: 16px !important;
  }
}
</style>
